import React, { FC } from 'react';

import './Background.scss';

export interface BackgroundProps {}

const Background: FC<BackgroundProps> = () => <div className="enkrateia-ticket-background"></div>;

export default Background;
